"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: miimosa/common/v1/financial_rank.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.financialRankToJSON = exports.financialRankFromJSON = exports.FinancialRank = void 0;
/* eslint-disable */
exports.FinancialRank = {
    FINANCIAL_RANK_UNSPECIFIED: "FINANCIAL_RANK_UNSPECIFIED",
    FINANCIAL_RANK_JUNIOR: "FINANCIAL_RANK_JUNIOR",
    FINANCIAL_RANK_SENIOR: "FINANCIAL_RANK_SENIOR",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function financialRankFromJSON(object) {
    switch (object) {
        case 0:
        case "FINANCIAL_RANK_UNSPECIFIED":
            return exports.FinancialRank.FINANCIAL_RANK_UNSPECIFIED;
        case 1:
        case "FINANCIAL_RANK_JUNIOR":
            return exports.FinancialRank.FINANCIAL_RANK_JUNIOR;
        case 2:
        case "FINANCIAL_RANK_SENIOR":
            return exports.FinancialRank.FINANCIAL_RANK_SENIOR;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.FinancialRank.UNRECOGNIZED;
    }
}
exports.financialRankFromJSON = financialRankFromJSON;
function financialRankToJSON(object) {
    switch (object) {
        case exports.FinancialRank.FINANCIAL_RANK_UNSPECIFIED:
            return "FINANCIAL_RANK_UNSPECIFIED";
        case exports.FinancialRank.FINANCIAL_RANK_JUNIOR:
            return "FINANCIAL_RANK_JUNIOR";
        case exports.FinancialRank.FINANCIAL_RANK_SENIOR:
            return "FINANCIAL_RANK_SENIOR";
        case exports.FinancialRank.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.financialRankToJSON = financialRankToJSON;
//# sourceMappingURL=financial_rank.js.map